import { Component, computed, input, model } from '@angular/core';
import { AssetDetailTabs } from '../types';
import { CommonModule } from '@angular/common';
import { AssetDetail } from '../../services/asset-service/types';
import { format } from 'date-fns';
import { ACCESS_LABEL_MAP } from '../../shared/asset-access-type/constants';

@Component({
  selector: 'asset-detail-content',
  templateUrl: './asset-detail-content.html',
  styleUrl: './asset-detail-content.scss',
  imports: [CommonModule],
})
export class AssetDetailContent {
  asset = input.required<AssetDetail>();
  activeTab = model.required<AssetDetailTabs>();

  timePeriod = computed(() => {
    const hasTimePeriod = Boolean(this.asset().time_period_start && this.asset().time_period_end);
    if (hasTimePeriod) {
      return `${this.asset().time_period_start} - ${this.asset().time_period_end}`;
    }
    return null;
  });

  isDatasetOrAiToolAgent = computed(() => {
    return (
      this.asset().asset_type === 'Dataset' ||
      this.asset().asset_type === 'AI Tool' ||
      this.asset().asset_type === 'AI Agent'
    );
  });

  lastUpdatedDisplay = computed(() => {
    if (!this.asset().last_updated_at) return undefined;
    return format(this.asset().last_updated_at, 'd MMM Y');
  });

  geographicalCoverageDisplay = computed(() => {
    if (
      this.asset().regions.length === 0
      // && this.asset().countries.length === 0
    ) {
      return undefined;
    }
    // return this.asset().regions.concat(this.asset().countries).join(', ');
    return this.asset().regions.join(', ');
  });

  accessTypeDisplay = computed(() => {
    return this.asset().access;
  });
}
